import Icon from 'components/Icon';
import Pill from 'components/Widget/Pill';
import { DesignSystemSection } from 'designSystem/types';
import { DS_TAB_CHROME } from 'designSystem/config';
import { pathsToDsLinks } from 'designSystem/content/util';
import useDsNavigation from 'hooks/useDsNavigation';
import * as S from './styles';

interface DsUpdateCardProps {
	section: DesignSystemSection;
	paths?: string[];
	isMobile?: boolean;
	showPendingNote?: boolean;
}

const DsUpdateCard = ({ section, paths = [], isMobile, showPendingNote }: DsUpdateCardProps) => {
	const { openTab } = useDsNavigation();
	const chrome = DS_TAB_CHROME[section];
	const title = `${chrome.label} Updated`;
	const tabTargets = pathsToDsLinks(paths, section);

	const onItemClick = (e: React.MouseEvent, contentPath: string) => {
		e.stopPropagation();
		openTab(section, contentPath);
	};

	return (
		<S.UpdateCard isMobile={isMobile}>
			<S.UpdateTitleRow>
				<S.UpdateIcon>
					<Icon type={chrome.icon} width={16} height={16} />
				</S.UpdateIcon>
				<S.UpdateTitle>{title}</S.UpdateTitle>
			</S.UpdateTitleRow>
			{tabTargets.length > 0 && (
				<S.ItemList>
					{tabTargets.map((target, i) =>
						target.deleted ? (
							<Pill
								key={`deleted-${target.label}-${i}`}
								label={target.label}
								variant="deleted"
								tooltip="Removed from design system"
							/>
						) : target.contentPath && !showPendingNote ? (
							<Pill
								key={target.contentPath}
								label={target.label}
								tooltip="Click to open in design system"
								onClick={(e) => onItemClick(e, target.contentPath!)}
							/>
						) : (
							<Pill key={target.contentPath ?? i} label={target.label} variant="muted" />
						)
					)}
				</S.ItemList>
			)}
			{showPendingNote && (
				<S.UpdateNote isMobile={isMobile}>Changes apply when chat completes</S.UpdateNote>
			)}
		</S.UpdateCard>
	);
};

export default DsUpdateCard;
